import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DateTime } from 'luxon';
import './IdleBanner.css';

const IdleBanner = () => {
  const [idle, setIdle] = useState(false);
  const [movie, setMovie] = useState();

  const topRated = useSelector((state) => state.topRated);
  const trending = useSelector((state) => state.trending);
  const action = useSelector((state) => state.action);
  const comedy = useSelector((state) => state.comedy);
  const horror = useSelector((state) => state.horror);
  const romance = useSelector((state) => state.romance);
  const animation = useSelector((state) => state.animation);
  const history = useSelector((state) => state.history);
  const tvNews = useSelector((state) => state.tvNews);
  const documentary = useSelector((state) => state.documentary);
  const allGenres = useSelector((state) => state.genres);

  let allMovies;

  if (Array.isArray(animation.results)) {
    allMovies = topRated.results.concat(trending.results,
      action.results, comedy.results, horror.results, romance.results,
      animation.results, history.results, tvNews.results, documentary.results);
  } else {
    allMovies = [{
      adult: false,
      backdrop_path: '/h8gHn0OzBoaefsYseUByqsmEDMY.jpg',
      genre_ids: [28, 53, 80],
      id: 603692,
      original_language: 'en',
      original_title: 'John Wick: Chapter 4',
      overview: 'With the price on his head ever increasing, John Wick uncovers a path to defeating The High Table. But before he can earn his freedom, Wick must face off against a new enemy with powerful alliances across the globe and forces that turn old friends into foes.',
      popularity: 3911.607,
      poster_path: '/vZloFAK7NmvMGKE7VkF5UHaz0I.jpg',
      release_date: '2023-03-22',
      title: 'John Wick: Chapter 4',
      video: false,
      vote_average: 7.9,
      vote_count: 2828,
    }];
  }

  // set interval to change movie being displayed
  useEffect(() => {
    const interval = setInterval(() => {
      setMovie(
        allMovies[
          Math.floor(Math.random() * allMovies.length - 1)
        ],
      );
    }, 7000);
    return () => clearInterval(interval);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const truncate = (str, n) => (
    str?.length > n ? `${str.substr(0, n - 1)}...` : str);

  // Filter categories for a particular movie
  let results;

  if (!Array.isArray(allGenres.genres)) {
    results = [{ id: 1, name: 'comedy' }];
  } else {
    results = allGenres.genres.filter((el) => movie?.genre_ids
      .find((element) => element === el.id));
  }

  const categories = results.map((result) => result.name).join(', ');

  // timer and events

  const events = ['click', 'scroll', 'load', 'keydown'];

  const addEvents = () => {
    events.forEach((eventName) => {
      window.addEventListener(eventName, () => {
        localStorage.setItem('defaultTime', DateTime.now().c.minute);
        setIdle(false);
      });
    });
  };

  const startTime = localStorage.getItem('defaultTime');
  const timeDiff = DateTime.now().c.minute - startTime;

  const removeEvents = () => {
    events.forEach((eventName) => {
      window.removeEventListener(eventName, () => {
        setIdle(true);
      });
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (timeDiff >= 1.8) {
      setIdle(true);
    }
    addEvents();

    return (() => {
      removeEvents();
    });
  });

  return (
    <>
      { idle && window.location.pathname !== '/login' && window.location.pathname !== '/sign-up' && window.location.pathname !== '/help' ? (
        <div className="idle-banner-section">
          <div className="idle-banner-container">
            <div
              className="idle-movie"
              style={{
                backgroundSize: 'cover',
                backgroundImage: `url("https://image.tmdb.org/t/p/original/${movie?.backdrop_path}")`,
                backgroundPosition: 'center center',
              }}
            >
              <div className="home-movie-contents">
                <h1 className="home-movie-title">
                  {movie?.title || movie?.name || movie?.original_name}
                </h1>
                <p className="home-movie-description">
                  {truncate(movie?.overview, 200)}
                </p>
                <div className="release-date-category">
                  <p className="category">
                    {categories ? (
                      <>
                        <span className="banner-small">Category:&nbsp;</span>
                        <span>{categories}</span>
                      </>
                    ) : ''}
                    {' '}

                  </p>
                  <p className="release-date">
                    {movie?.release_date ? (
                      <>
                        <span className="banner-small">Release Date:&nbsp;</span>
                        <span>
                          {new Date(movie?.release_date).toLocaleDateString('en-us', {
                            weekday: 'long', year: 'numeric', month: 'short', day: 'numeric',
                          })}
                        </span>
                      </>
                    ) : ''}
                  </p>
                </div>
              </div>
              <div className="home-movie--fadeBottom" />
            </div>
          </div>
        </div>
      ) : ''}
    </>
  );
};

export default IdleBanner;
